import React from 'react';
import { ScrollReveal } from './ScrollReveal';
import { SectionCTA } from './SectionCTA';
export function Reframe() {
  return <section className="py-24 px-4 bg-gradient-to-b from-[#050510] to-[#0a0a1f] text-center" data-id="element-285">
      <div className="container mx-auto max-w-4xl" data-id="element-286">
        <ScrollReveal data-id="element-287">
          <h2 className="text-4xl md:text-6xl font-bold mb-8 leading-tight" data-id="element-288">
            No estás fallando. <br data-id="element-289" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-red-400 to-orange-400" data-id="element-290">
              Te falta estructura.
            </span>
          </h2>
        </ScrollReveal>

        <ScrollReveal delay={0.2} data-id="element-291">
          <p className="text-xl md:text-2xl text-gray-300 mb-12 leading-relaxed" data-id="element-292">
            La mayoría intenta crecer seguidores cuando debería estar{' '}
            <span className="text-white font-bold border-b-2 border-cyan-500" data-id="element-293">
              creando activos digitales
            </span>
            .
          </p>
        </ScrollReveal>

        <ScrollReveal delay={0.4} data-id="element-294">
          <div className="glass-card p-8 md:p-12 rounded-3xl inline-block max-w-3xl mx-auto border border-cyan-500/20 shadow-[0_0_50px_rgba(0,212,255,0.1)]" data-id="element-295">
            <p className="text-lg md:text-xl text-gray-300 mb-6" data-id="element-296">
              Este programa no es teoría. Es ejecución pura.
            </p>
            <div className="flex flex-col md:flex-row items-center justify-center gap-4 text-white font-bold text-xl" data-id="element-297">
              <span className="opacity-50 line-through decoration-red-500" data-id="element-298">
                No es motivación
              </span>
              <span className="hidden md:block text-cyan-500" data-id="element-299">•</span>
              <span className="opacity-50 line-through decoration-red-500" data-id="element-300">
                No es inspiración
              </span>
              <span className="hidden md:block text-cyan-500" data-id="element-301">•</span>
              <span className="text-cyan-400 scale-110" data-id="element-302">
                Es creación + venta
              </span>
            </div>
          </div>
        </ScrollReveal>

        <SectionCTA headline="Empieza a construir tu activo digital hoy" buttonText="ACCEDER AL PROGRAMA — $16.39" data-id="element-303" />
      </div>
    </section>;
}